import { z } from 'zod';
import { Box } from '@/shared/ui';

import { ItemSelection } from '@/features/dashboard/components/AppForm/AppForm/components/ItemSelection';
import { TabName } from '@/features/dashboard/components/AppForm/AppForm/components/TabName';
import type { SpotHistoryTableValues } from '@/features/dashboard/components/AppForm/AppForm/context/types';
import { DrawerStep } from '@/features/dashboard/components/Drawer/types';
import Heading from '@/features/dashboard/components/Heading';
import { SPOT_HISTORY_TABLE_MAX_ITEMS } from '@/features/dashboard/constants/const';
import type { SpotHistoryTableWidgetV2 } from '@/features/dashboard/types';
import { AppType } from '@/features/dashboard/types';

import type { FormAppDefinition } from '../types';
import {
  buildSpotHistoryTable,
  NameSchema,
  SymbolsStateSchema,
  tableToFormValues
} from './_helpers';

export const spotHistoryTableDefinition: FormAppDefinition<
  SpotHistoryTableValues,
  SpotHistoryTableWidgetV2
> = {
  type: AppType.SpotHistoryTable,
  drawerStep: DrawerStep.SpotHistoryTable,
  dashboardControls: { edit: true },
  widgetControls: { export: true },
  maxItems: SPOT_HISTORY_TABLE_MAX_ITEMS,
  initialValues: {
    name: 'Spot History Table',
    type: AppType.SpotHistoryTable,
    symbols: { active: [], backlog: [] }
  },
  schema: z.object({
    id: z.string().optional(),
    type: z.literal(AppType.SpotHistoryTable),
    name: NameSchema,
    symbols: SymbolsStateSchema
  }),
  Form: () => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Heading
        subtitle='Set up your table preferences and data'
        title='Configure spot history table'
      />
      <TabName />
      <ItemSelection />
    </Box>
  ),
  toWidget: values => buildSpotHistoryTable(values.name, values.symbols, values.id),
  canEditWidget: (w): w is SpotHistoryTableWidgetV2 => w.type === 'spot_history_table',
  fromWidget: w => tableToFormValues(w, AppType.SpotHistoryTable)
};
